export default [
  {
    value: 'title',
    text: 'Заголовок',
    type: 'string',
    description: ''
  },
  {
    value: 'status',
    text: 'Статус',
    width: 140,
    type: 'text',
    description: ''
  },
  {
    value: 'slug',
    text: 'Уникальное имя для URL',
    width: 190,
    type: 'string',
    description: ''
  },
  {
    value: 'copySlug',
    text: 'Скопировать',
    width: 80,
    align: 'end',
    type: 'actions',
    sortable: false,
    description: ''
  },
  {
    value: 'translations',
    text: 'Языки',
    width: 160,
    type: 'string',
    sortable: false,
    description: ''
  },
  {
    value: 'createdAt',
    text: 'Создано',
    width: 180,
    type: 'date',
    description: ''
  },
  {
    text: 'Изменено',
    value: 'updatedAt',
    width: 180,
    type: 'date',
    description: ''
  },
  {
    text: 'Сортировка',
    value: 'sortOrder',
    width: 120,
    type: 'string',
    description: ''
  },
  {
    value: 'actions',
    text: 'Действия',
    width: 105,
    align: 'end',
    type: 'actions',
    sortable: false,
    description: ''
  }
]
